import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  breakpoints,
  IBasicStyledProps,
  theme,
} from '@notino/react-styleguide';
import { GetReviewsQuery } from '@notino/shared/definitions/types';

import { styled } from '@linaria/react';

type Props = {
  attributes: NonNullable<
    NonNullable<GetReviewsQuery['reviewsAndFilters']>['data']
  >['reviews'][number]['attributes'];
} & IBasicStyledProps;

const Wrapper = styled.div`
  h4 {
    margin-bottom: 12px;
    ${theme.typography.labelLarge}

    &:nth-of-type(2) {
      margin-top: 24px;
    }
  }

  ul {
    all: unset;
    display: flex;
    flex-direction: column;
    gap: 12px;

    li {
      all: unset;
      display: flex;

      ${theme.typography.bodyRegular}
      @media (min-width: ${breakpoints.md}) {
        ${theme.typography.bodyLarge}
      }

      &::before {
        content: '•';
        color: ${theme.color.icon.disabled};
        padding: 0 26px 0 9px;
        display: block;
        font-size: 2rem;
      }
    }
  }
`;

export const ProsAndCons = ({ attributes, ...rest }: Props) => {
  const pros = attributes?.pros || [];
  const cons = attributes?.cons || [];

  if (pros.length === 0 && cons.length === 0) {
    return null;
  }

  return (
    <Wrapper {...rest}>
      {pros.length > 0 && (
        <>
          <h4>
            <FormattedMessage
              id="reviews.attributes.pros"
              defaultMessage="Klady"
            />
          </h4>
          <ul>
            {pros.map((pro) => (
              <li key={pro}>{pro}</li>
            ))}
          </ul>
        </>
      )}

      {cons.length > 0 && (
        <>
          <h4>
            <FormattedMessage
              id="reviews.attributes.cons"
              defaultMessage="Zápory"
            />
          </h4>
          <ul>
            {cons.map((con) => (
              <li key={con}>{con}</li>
            ))}
          </ul>
        </>
      )}
    </Wrapper>
  );
};
